<template>
    <div class="photo_sphere">
        <div id="viewer" ref="viewer"></div>
        <div class="poster" v-if="!isFirstPlay" :style="`background-image: url(${poster});`"></div>
        <div class="play" v-if="!isFirstPlay && !loading" @click="play">
            <template v-if="$i18n.locale == 'en'">
                <img v-if="!isPhone" src="../assets/images/icon_play_prompt_en.png" alt=""/>
                <img v-else src="../assets/images/icon_play_prompt_en1.png" alt=""/>
            </template>
            <template v-if="$i18n.locale == 'zh'">
                <img v-if="!isPhone" src="../assets/images/icon_play_prompt_zh.png" alt=""/>
                <img v-else src="../assets/images/icon_play_prompt_zh1.png" alt=""/>
            </template>
        </div>
        <template v-if="isFirstPlay">
            <VrControls :playing="playing" :zoom="zoom" @play="play" @pause="pause" @changeZoomSize="changeZoom"/>
        </template>
    </div>
</template>

<script>
import {Viewer} from '@photo-sphere-viewer/core';
import '@photo-sphere-viewer/core/index.css';
import {VideoPlugin} from '@photo-sphere-viewer/video-plugin';
import '@photo-sphere-viewer/video-plugin/index.css';
import {EquirectangularVideoAdapter} from '@photo-sphere-viewer/equirectangular-video-adapter';
import { mapState } from 'vuex';
import VrControls from './vrControls.vue';
export default {
    name: "videoSphereViewer",
    props: ['poster', 'src', 'fov', 'pan', 'tilt'],
    data() {
        return {
            viewer: null,
            videoPlugin: null,
            isFirstPlay: false, //第一次播放，封面、点击手势控制
            playing: false, //播放状态
            loading: false, //加载
            zoom: 50
        };
    },
    computed: {
        ...mapState(['isPhone']),
    },
    components: {
        VrControls
        
    },
    mounted() {
        this.viewer = new Viewer({
            container: this.$refs.viewer,
            adapter: [EquirectangularVideoAdapter,{
                // autoplay: true
            }],
            // panorama: {
            //     source: '/a5673d61b3bc134ccf1550886a7da9a5.mp4'
            // },
            defaultZoomLvl: this.zoom,
            loadingImg: require('@/assets/images/icon_panorama_loading_img.gif'),
            navbar: false,
            moveInertia: true,
            plugins: [
                [VideoPlugin, {
                    bigbutton: false,
                    progressbar: false,
                }]
            ],
        });
        // 加载完成
        // this.viewer.addEventListener('panorama-loaded', () => {
        //     this.loading = false;
        // })
        // 缩放
        this.viewer.addEventListener('zoom-updated', ({ zoomLevel }) => {
            this.zoom = zoomLevel;
        })
        // 视频播放状态更新
        this.videoPlugin = this.viewer.getPlugin(VideoPlugin);
        this.videoPlugin.addEventListener('play-pause', ({ playing }) => {
            if (!this.isFirstPlay) {
                this.isFirstPlay = playing;
                this.$emit('firstPlay');
            }
            this.playing = playing;
        })
    },
    destroyed() {},
    watch: {
        src: {
            handler: function(val) {
                this.loading = true;
                let zoom = this.fov / 140 * 100;
                this.zoom = zoom;
                this.$nextTick(() => {
                    this.viewer.setPanorama({ 
                        source: val,
                    }, {
                        // yaw: this.pan ? this.pan : 0,
                        // pitch: this.tilt ? this.tilt : 0,
                        yaw: this.pan ? (this.pan - 180) / 180 * Math.PI : 0,
                        pitch: this.tilt ? this.tilt / 180 * Math.PI : 0,
                        // yaw: (205 - 180) / 180 * Math.PI,
                        // pitch: 0 / 180 * Math.PI,
                        zoom,
                    }).then(() => {
                        this.loading = false;
                    });
                })
            },
            immediate: true
        }
    },
    methods: {
        play({ speed }) {
            this.$emit('play');
            this.videoPlugin.video.play();
            this.videoPlugin.video.loop = false;
            if (speed) { 
                this.videoPlugin.video.playbackRate = speed;
            }
        },
        pause() { 
            this.videoPlugin.video.pause();
        },
        changeZoom({ zoom }) {
            if (zoom < 0) zoom = 0;
            if (zoom > 100) zoom = 100;
            this.zoom = zoom;
            this.viewer.zoom(zoom);
        },
    },
};
</script>

<style scoped lang="scss">
.photo_sphere{
    position: relative;
    width: 100%;
    height: 100%;
}
#viewer{
    position: absolute;
    width: 100%;
    height: 100%;
}
.poster{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: no-repeat center/cover;
}
.play{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 3.5rem;
    cursor: pointer;
    @media only screen and (max-width: 640px) {
        width: 4.5rem;
    }
}
</style>